import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const ULStyled = styled.ul`
    ${({ theme }) => {
    return css`
      box-shadow:  0 ${rem(5)} ${rem(10)} rgb(0 0 0 / 10%);
      position: absolute;
      left: 0;
      margin: ${rem(-2)} 0 0;
      width: 100%;
      list-style: none;
      padding: 0;
      max-height: ${rem(400)};
      overflow: auto;
      border-radius: ${rem(2)};
      border: ${rem(1)} solid ${theme.colors.neutral.grayLight2};
      border-top-color: ${theme.colors.neutral.white};
      border-width: ${rem(1)} ${rem(1)} ${rem(2)};
      background-color: ${theme.colors.neutral.white};
      z-index: 1;
    `;
  }}
`;

export const LIStyled = styled.li`
    ${({ theme }) => {
    return css`
      cursor: pointer;
      height: ${rem(60)};
      line-height: ${rem(60)};
      padding: 0 ${rem(10)};
      border-bottom: ${rem(1)} solid ${theme.colors.neutral.grayLight3};
      color: ${theme.colors.neutral.grayDark2};
      font-size: ${rem(18)};
      letter-spacing: ${rem(1)};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      &:last-child {
        border-bottom: 0;
      }
      &:focus {
        background-color: ${theme.colors.neutral.grayLight2};
      }
    }`;
  }}
`;
